// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pp-hero {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 16px;
}

.pp-avatar {
  flex-shrink: 0;
  width: 68px;
  height: 68px;
  border-radius: 50%;
  object-fit: cover;
}

.pp-avatar-fallback {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--grad-brand);
  color: #fff;
  font-family: var(--font-display);
  font-size: 1.25rem;
  font-weight: 800;
}

.pp-hero-info {
  min-width: 0;
}

.pp-hero-info h1 {
  font-family: var(--font-display);
  font-size: 1.34rem;
  font-weight: 800;
  line-height: 1.2;
  color: var(--text);
  margin-bottom: 6px;
}

.pp-services {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
}

.pp-services li {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
}

.pp-services strong {
  display: block;
  font-size: 0.92rem;
  font-weight: 700;
  color: var(--text);
}

.pp-services p {
  margin-top: 3px;
  font-size: 0.83rem;
  line-height: 1.55;
  color: var(--muted);
}

.pp-services span {
  flex-shrink: 0;
  font-family: var(--font-display);
  font-size: 0.94rem;
  font-weight: 700;
  color: var(--brand);
}

.pp-ratings {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 12px;
}

.pp-ratings li {
  padding-bottom: 14px;
  border-bottom: 1px solid var(--border);
}

.pp-ratings li:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

.pp-rating-head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 9px;
  margin-bottom: 5px;
}

.pp-rating-stars {
  display: inline-flex;
  gap: 1px;
  color: var(--border-strong);
}

.pp-star-on {
  color: #f59e0b;
  fill: #fbbf24;
}

.pp-rating-meta {
  font-size: 0.76rem;
  color: var(--muted2);
}

.pp-ratings p {
  font-size: 0.87rem;
  line-height: 1.6;
  color: var(--text-soft);
}

@media (max-width: 520px) {
  .pp-services li {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/client/ProviderProfile.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".pp-hero {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 16px;\n}\n\n.pp-avatar {\n  flex-shrink: 0;\n  width: 68px;\n  height: 68px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.pp-avatar-fallback {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--grad-brand);\n  color: #fff;\n  font-family: var(--font-display);\n  font-size: 1.25rem;\n  font-weight: 800;\n}\n\n.pp-hero-info {\n  min-width: 0;\n}\n\n.pp-hero-info h1 {\n  font-family: var(--font-display);\n  font-size: 1.34rem;\n  font-weight: 800;\n  line-height: 1.2;\n  color: var(--text);\n  margin-bottom: 6px;\n}\n\n.pp-services {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.pp-services li {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  background: var(--bg);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n}\n\n.pp-services strong {\n  display: block;\n  font-size: 0.92rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.pp-services p {\n  margin-top: 3px;\n  font-size: 0.83rem;\n  line-height: 1.55;\n  color: var(--muted);\n}\n\n.pp-services span {\n  flex-shrink: 0;\n  font-family: var(--font-display);\n  font-size: 0.94rem;\n  font-weight: 700;\n  color: var(--brand);\n}\n\n.pp-ratings {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  margin-top: 12px;\n}\n\n.pp-ratings li {\n  padding-bottom: 14px;\n  border-bottom: 1px solid var(--border);\n}\n\n.pp-ratings li:last-child {\n  padding-bottom: 0;\n  border-bottom: 0;\n}\n\n.pp-rating-head {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 9px;\n  margin-bottom: 5px;\n}\n\n.pp-rating-stars {\n  display: inline-flex;\n  gap: 1px;\n  color: var(--border-strong);\n}\n\n.pp-star-on {\n  color: #f59e0b;\n  fill: #fbbf24;\n}\n\n.pp-rating-meta {\n  font-size: 0.76rem;\n  color: var(--muted2);\n}\n\n.pp-ratings p {\n  font-size: 0.87rem;\n  line-height: 1.6;\n  color: var(--text-soft);\n}\n\n@media (max-width: 520px) {\n  .pp-services li {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
